import { Table, TableBody, TableRow, TableHead, TableContainer, TableCell } from '@mui/material'
import { makeStyles, styled } from '@mui/styles'
import EditField from 'components/DocumentDetail/Editor/EditField'
import EditRow from 'components/DocumentDetail/Editor/EditRow'
import { Field } from 'components/DocumentDetail/types'
import FullHeightFlexContainer from 'components/ui/FullHeightFlexContainer'
import { DocumentOrderForm } from 'entities/DocumentsOrderForm'
import getOrderFormFields from 'entities/getOrderFormFields'
import { useMemo } from 'react'
import { ValidationValueMessage } from 'react-hook-form'

interface Props {
  docDetail: DocumentOrderForm
}

const SubTitleCell = styled(TableCell)({
  fontWeight: 600,
})

const useStyles = makeStyles({
  fixedTable: {
    tableLayout: 'fixed',
  },
  labelCell: {
    width: '40%',
  },
})

function Base({ docDetail }: Props) {
  const classes = useStyles()
  const { docInfo } = docDetail
  const { isVerifyRegistered } = docInfo
  const currentFields = useMemo(() => getOrderFormFields(docDetail), [docDetail])
  const isChecking = docDetail.isChecking

  const genRows = (title, fields: Field[]) => {
    if (!fields.length) return null

    let hasDisplay = false
    const hiddenStyle = { display: 'none' }

    const rows = fields.map((field) => {
      const required =
        field.rules?.required === true ||
        !!(field.rules?.required as ValidationValueMessage<boolean>)?.value
      const disabled = !docDetail.canEdit() || field.compProps.disabled

      /**
       * - only show when config[key].display is true
       * - hide if field is not verifiable item during checking
       */
      let style
      if (
        field.config?.display === false ||
        (!isVerifyRegistered && field.config?.verify === false && isChecking)
      ) {
        style = hiddenStyle
      } else {
        hasDisplay = true
      }
      return (
        <EditRow style={style} key={field.name} label={field.label} required={required}>
          <EditField
            {...field}
            compProps={{ ...field.compProps, disabled }}
            hlKey={`${field.name}\\.`}
          />
        </EditRow>
      )
    })

    return (
      <>
        <TableRow style={hasDisplay ? undefined : hiddenStyle}>
          <SubTitleCell colSpan={2}>{title}</SubTitleCell>
        </TableRow>
        {rows}
      </>
    )
  }

  return (
    <FullHeightFlexContainer>
      <TableContainer>
        <Table
          stickyHeader
          size={'medium'}
          className={classes.fixedTable}
          aria-label="base fields table"
        >
          <TableHead data-testid="table-head-base-edit">
            <TableRow>
              <TableCell className={classes.labelCell}>項目名</TableCell>
              <TableCell>編集結果</TableCell>
            </TableRow>
          </TableHead>
          <TableBody data-testid="table-body-base-edit">
            {genRows('一般情報', currentFields.headerBase)}

            {genRows('発行元情報', currentFields.headerOrderer)}

            {genRows('注文先情報', currentFields.headerSupplier)}

            {genRows('納入先情報', currentFields.headerDelivery)}

            {genRows('その他', currentFields.other)}
          </TableBody>
        </Table>
      </TableContainer>
    </FullHeightFlexContainer>
  )
}

export default Base
